import { Injectable, signal } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

const TOKEN_KEY = 'syncc_access_token';

@Injectable({ providedIn: 'root' })
export class TokenService {
    private _token: string | null = null;

    readonly driverName    = signal('Conductor');
    readonly driverInitial = signal('C');

    async init(): Promise<void> {
        const { value } = await Preferences.get({ key: TOKEN_KEY });
        this._token = value;
        if (value) this.decodeProfile(value);
    }

    getToken(): string | null {
        return this._token;
    }

    async setToken(token: string): Promise<void> {
        this._token = token;
        this.decodeProfile(token);
        await Preferences.set({ key: TOKEN_KEY, value: token });
    }

    async clearToken(): Promise<void> {
        this._token = null;
        this.driverName.set('Conductor');
        this.driverInitial.set('C');
        await Preferences.remove({ key: TOKEN_KEY });
    }

    decodeProfile(token: string): void {
        try {
            const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
            const bytes = new Uint8Array(atob(b64).split('').map(c => c.charCodeAt(0)));
            const payload = JSON.parse(new TextDecoder().decode(bytes));
            const full = payload.name || payload.firstName || 'Conductor';
            this.driverName.set(full.split(' ')[0]);
            this.driverInitial.set(full.charAt(0).toUpperCase());
        } catch {
            this.driverName.set('Conductor');
            this.driverInitial.set('C');
        }
    }
}
